import React from 'react';
import ManageConvenios from '../components/settings/ManageConvenios';

export default function Convenios() {
  return <ManageConvenios />;
}
